/* eslint-disable jsx-a11y/anchor-is-valid */
import styled from 'styled-components';
import { Icon } from 'fpay-ui';
import React from 'react';

const ModalBackground = styled.div`
  position: absolute;
  z-index: 999;
  background-color: rgb(0 0 0 / 50%);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  touch-action: none;
  justify-content: center;  
  animation-name: grow-modal;
  animation-duration: 0.4s;
  animation-timing-function: ease;
  @keyframes grow-modal {
    0% { opacity: .2; }
    25% { opacity: .4; }
    50% { opacity: .6; }
    75% { opacity: .8; }
    100% { opacity: 1; }
  `;
const ModalContent = styled.div`
  width: 344px;
  height: fit-content;
  border-radius: 6px;
  box-shadow: 0px 8px 12px #0000003D;
  background-color: #fff;
  z-index: 9999;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 5px;
  border: 1px;
  border-color: #707070;
  overflow-y: hidden;
  animation-name: grow-modal;
  animation-duration: .2s;
  animation-timing-function: ease;
  @media (max-width: 360px) {
    width: 312px;
    padding-bottom: 3px;
  @keyframes grow-modal {
    0% { opacity: .2; }
    25% { opacity: .4; }
    50% { opacity: .6; }
    75% { opacity: .8; }
    100% { opacity: 1; }
  }
`;
const ModalClose = styled.span`
  display: flex;
  justify-content: flex-end;
  padding-right: 0px;
  padding-top: 12px;
  top: 0;
  margin-right: 0px;
  @media (max-width: 360px) {
    padding-right: 2px;
    padding-top: 14px;
  }
`;
const Modal = ({ children, fClose }) => {
  const fCloseByBackground = (evn) => {
    evn.preventDefault();
    if (evn.target.dataset.js === 'root-modal' && fClose) {
      fClose();
    }
  };

  return (
    <>
      <ModalBackground onClick={fCloseByBackground} data-js="root-modal">
        <ModalContent>
          <ModalClose>
            <a href="" onClick={fClose}>
              <Icon icon="ic-close-circle" width="24px" height="24px" color="gray500" />
            </a>
          </ModalClose>
          {children}
        </ModalContent>
      </ModalBackground>
    </>
  );
};

export default Modal;
